// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogIn, Loader2 } from "lucide-react";
import Layout from "../../components/layout/Layout";
import { useKeycloak } from "../../context/KeycloakProvider";
import { usePermissions } from "../../hooks/usePermissions";
import { getFirstAccessibleRoute } from "../../routes/routeConfig";
import { Navigate } from "react-router-dom";

const LoginPage = () => {
  const navigate = useNavigate();
  const { authenticated, loading, login } = useKeycloak();
  const { userPermissions, keycloakRoles } = usePermissions();

  // If already authenticated, redirect to first accessible route
  if (authenticated) {
    const firstAccessibleRoute = getFirstAccessibleRoute(
      keycloakRoles,
      userPermissions,
    );
    return <Navigate to={firstAccessibleRoute} replace />;
  }

  useEffect(() => {
    if (authenticated) {
      navigate("/admin/dashboard");
    }
  }, [authenticated, navigate]);

  const handleLogin = () => {
    login();
  };

  if (loading) {
    return (
      <Layout>
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <Loader2 className="w-8 h-8 text-blue-500 animate-spin mx-auto mb-4" />
            <p className="text-gray-600">Loading...</p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div>
            <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-blue-100">
              <LogIn className="h-6 w-6 text-blue-600" />
            </div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Sign in to your account
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              Welcome to Fair Urban Space
            </p>
          </div>

          <div className="mt-8 space-y-6">
            <div className="text-center">
              <button
                onClick={handleLogin}
                className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                <LogIn className="h-5 w-5 mr-2" />
                Sign in with Keycloak
              </button>
            </div>

            <div className="text-center">
              <Link
                to="/register"
                className="text-blue-600 hover:text-blue-500"
              >
                Need an account? Sign up
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default LoginPage;
